module.exports = __webpack_public_path__ + "static/media/shine.65aebe69.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/my-gift/shine.png
// module id = 514
// module chunks = 1